import { render } from "./ReferansImage.vue?vue&type=template&id=25ec4752"
import script from "./ReferansImage.vue?vue&type=script&lang=js"
export * from "./ReferansImage.vue?vue&type=script&lang=js"

import "./ReferansImage.vue?vue&type=style&index=0&id=25ec4752&lang=css"
script.render = render

export default script